// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { VacancyCandidatesSearchRequestDto } from '../models';
// @ts-ignore
import type { VacancyCandidatesSearchResponseDto } from '../models';
// @ts-ignore
import type { VacancyCandidatesSortValuesDto } from '../models';
/**
 * VacancyCandidatesSearchRestApi - axios parameter creator
 */
export const VacancyCandidatesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {VacancyCandidatesSortValuesDto} vacancyProjectsSort 
         * @param {VacancyCandidatesSearchRequestDto} [vacancyCandidatesSearchRequestDto] Get filtered and sorted candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVacancyCandidates: async (page: number, pageSize: number, sortDirection: SortDirectionDto, vacancyProjectsSort: VacancyCandidatesSortValuesDto, vacancyCandidatesSearchRequestDto?: VacancyCandidatesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchVacancyCandidates', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchVacancyCandidates', 'pageSize', pageSize)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('searchVacancyCandidates', 'sortDirection', sortDirection)
            // verify required parameter 'vacancyProjectsSort' is not null or undefined
            assertParamExists('searchVacancyCandidates', 'vacancyProjectsSort', vacancyProjectsSort)
            const localVarPath = `/api/v1/vacancyCandidates/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (vacancyProjectsSort !== undefined) {
                localVarQueryParameter['vacancyProjectsSort'] = vacancyProjectsSort;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vacancyCandidatesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VacancyCandidatesSearchRestApi - functional programming interface
 */
export const VacancyCandidatesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VacancyCandidatesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {VacancyCandidatesSortValuesDto} vacancyProjectsSort 
         * @param {VacancyCandidatesSearchRequestDto} [vacancyCandidatesSearchRequestDto] Get filtered and sorted candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVacancyCandidates(page: number, pageSize: number, sortDirection: SortDirectionDto, vacancyProjectsSort: VacancyCandidatesSortValuesDto, vacancyCandidatesSearchRequestDto?: VacancyCandidatesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VacancyCandidatesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVacancyCandidates(page, pageSize, sortDirection, vacancyProjectsSort, vacancyCandidatesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VacancyCandidatesSearchRestApi.searchVacancyCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VacancyCandidatesSearchRestApi - factory interface
 */
export const VacancyCandidatesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VacancyCandidatesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {VacancyCandidatesSortValuesDto} vacancyProjectsSort 
         * @param {VacancyCandidatesSearchRequestDto} [vacancyCandidatesSearchRequestDto] Get filtered and sorted candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVacancyCandidates(page: number, pageSize: number, sortDirection: SortDirectionDto, vacancyProjectsSort: VacancyCandidatesSortValuesDto, vacancyCandidatesSearchRequestDto?: VacancyCandidatesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VacancyCandidatesSearchResponseDto> {
            return localVarFp.searchVacancyCandidates(page, pageSize, sortDirection, vacancyProjectsSort, vacancyCandidatesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VacancyCandidatesSearchRestApi - interface
 */
export interface VacancyCandidatesSearchRestApiInterface {
    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {VacancyCandidatesSortValuesDto} vacancyProjectsSort 
     * @param {VacancyCandidatesSearchRequestDto} [vacancyCandidatesSearchRequestDto] Get filtered and sorted candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchVacancyCandidates(page: number, pageSize: number, sortDirection: SortDirectionDto, vacancyProjectsSort: VacancyCandidatesSortValuesDto, vacancyCandidatesSearchRequestDto?: VacancyCandidatesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VacancyCandidatesSearchResponseDto>;

}

/**
 * VacancyCandidatesSearchRestApi - object-oriented interface
 */
export class VacancyCandidatesSearchRestApi extends BaseAPI implements VacancyCandidatesSearchRestApiInterface {
    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {VacancyCandidatesSortValuesDto} vacancyProjectsSort 
     * @param {VacancyCandidatesSearchRequestDto} [vacancyCandidatesSearchRequestDto] Get filtered and sorted candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchVacancyCandidates(page: number, pageSize: number, sortDirection: SortDirectionDto, vacancyProjectsSort: VacancyCandidatesSortValuesDto, vacancyCandidatesSearchRequestDto?: VacancyCandidatesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return VacancyCandidatesSearchRestApiFp(this.configuration).searchVacancyCandidates(page, pageSize, sortDirection, vacancyProjectsSort, vacancyCandidatesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

